export const formatTime = (
    sec: number,
    options?: {onlyMinutes?: boolean; showHours?: boolean},
) => {
    const totalSeconds = Math.max(0, Math.floor(sec));
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    const hours = Math.floor(minutes / 60);
    const remMinutes = minutes % 60;

    if (options?.onlyMinutes) {
        return `${minutes}`;
    }

    if (options?.showHours || hours > 0) {
        return `${String(hours).padStart(2, '0')}:${String(remMinutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }

    return `${String(remMinutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};
